module.exports = __webpack_public_path__ + "static/media/navigo-appoint-icon.9eafff3e.svg";